ReactContentQuery.ExternalScripts.loadTap = {
    onPostRender: function (wpContext, handlebarsContext) {
        SystemJS.import("/SiteAssets/js/melia.js").then((r) => SystemJS.import("components/menu").then(function(s){s.Menu.prototype.tap()}));
    }
}